import * as angular from 'angular';

export interface IScriptEditionService {
    contextualFormController(value?: angular.IFormController): angular.IFormController;
    scriptFormController(value?: angular.IFormController): angular.IFormController;
    script(value?: string): string;
    libraryCollection(value?: string[]): string[];
}

export class ScriptEditionService implements IScriptEditionService {
    static serviceId = 'scriptEditionService';
    static $inject = [];

    private _contextualFormController: angular.IFormController;
    private _scriptFormController: angular.IFormController;
    private _script: string;
    private _libraryCollection: string[];

    contextualFormController(value?: angular.IFormController): angular.IFormController {
        if (arguments.length) {
            this._contextualFormController = value;
        }
        return this._contextualFormController;
    }

    scriptFormController(value?: angular.IFormController): angular.IFormController {
        if (arguments.length) {
            this._scriptFormController = value;
        }
        return this._scriptFormController;
    }

    script(value?: string): string {
        if (arguments.length) {
            this._script = value;
        }
        return this._script;
    }

    libraryCollection(value?: string[]): string[] {
        if (arguments.length) {
            this._libraryCollection = value;
        }
        return this._libraryCollection;
    }

}